import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-0" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_5 = { class: "default-table-area style-two default-table-width" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "material-symbols-outlined fs-20" }
const _hoisted_11 = {
  class: "fw-medium text-dark",
  style: {"max-width":"250px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_12 = { class: "badge bg-secondary" }
const _hoisted_13 = { class: "text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "d-flex align-items-center gap-1" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Blog Posts",
      subTitle: "Management"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            class: "position-relative table-src-form me-0",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Search blog posts...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, "search", -1))
          ], 32),
          _createVNode(_component_RouterLink, {
            to: "/blog-posts/create",
            class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
                _createElementVNode("span", null, "Add New Article")
              ], -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "ID"),
                  _createElementVNode("th", { scope: "col" }, "Card Design"),
                  _createElementVNode("th", { scope: "col" }, "Title"),
                  _createElementVNode("th", { scope: "col" }, "Category"),
                  _createElementVNode("th", { scope: "col" }, "Date"),
                  _createElementVNode("th", { scope: "col" }, "Read Time"),
                  _createElementVNode("th", { scope: "col" }, "Status"),
                  _createElementVNode("th", { scope: "col" }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[4] || (_cache[4] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        class: "text-center py-4"
                      }, "Loading...", -1)
                    ])))
                  : (_ctx.filteredPosts.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[5] || (_cache[5] = [
                        _createElementVNode("td", {
                          colspan: "8",
                          class: "text-center py-4"
                        }, "No articles found.", -1)
                      ])))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredPosts, (p) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: p.post_id
                        }, [
                          _createElementVNode("td", null, "#" + _toDisplayString(p.post_id), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", {
                              class: "rounded-3 d-flex align-items-center justify-content-center text-white wh-40",
                              style: _normalizeStyle({ background: p.bg })
                            }, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(p.icon), 1)
                            ], 4)
                          ]),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(p.title), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(p.category), 1)
                          ]),
                          _createElementVNode("td", _hoisted_13, _toDisplayString(p.date), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(p.read_time), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge p-2 fs-12 fw-normal", p.is_active ? 'bg-success bg-opacity-10 text-success' : 'bg-danger bg-opacity-10 text-danger'])
                            }, _toDisplayString(p.is_active ? 'Active' : 'Inactive'), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_RouterLink, {
                                to: `/blog-posts/${p.post_id}/edit`,
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, {
                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                  _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, "edit", -1)
                                ])),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.deletePost(p.post_id)),
                                class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                              }, _cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, "delete", -1)
                              ]), 8, _hoisted_16)
                            ])
                          ])
                        ]))
                      }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}